// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicationProject
 */
export interface PublicationProject {
  /**
   *
   */
  id: string;
  /**
   *
   */
  slug: string;
}

/**
 * Check if a given object implements the PublicationProject interface.
 */
export function instanceOfPublicationProject(value: object): value is PublicationProject {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("slug" in value) || value["slug"] === undefined) return false;
  return true;
}

export function PublicationProjectFromJSON(json: any): PublicationProject {
  return PublicationProjectFromJSONTyped(json, false);
}

export function PublicationProjectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationProject {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    slug: json["slug"],
  };
}

export function PublicationProjectToJSON(json: any): PublicationProject {
  return PublicationProjectToJSONTyped(json, false);
}

export function PublicationProjectToJSONTyped(
  value?: PublicationProject | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    slug: value["slug"],
  };
}
